var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("Tool.Setting"),
        width: "650px",
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "el-tabs",
        {
          attrs: { type: "card" },
          model: {
            value: _vm.activeTabName,
            callback: function($$v) {
              _vm.activeTabName = $$v
            },
            expression: "activeTabName"
          }
        },
        [
          _c(
            "el-tab-pane",
            {
              attrs: {
                lazy: true,
                label: _vm.$t("SystemMaintenance.DisplaySettings"),
                name: "displaySettings"
              }
            },
            [
              _c(
                "el-form",
                {
                  staticStyle: { "margin-top": "20px" },
                  attrs: { "label-width": "120px", "label-position": "left" }
                },
                [
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "span",
                        {
                          staticClass: "title",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [_vm._v(_vm._s(_vm.$t("SystemMaintenance.SetAlias")))]
                      ),
                      _c("el-input", {
                        staticStyle: { width: "250px", "margin-right": "5px" },
                        attrs: {
                          disabled: !_vm.isEditLanguage,
                          placeholder: _vm.selectedLanguage.sysLabel
                        },
                        model: {
                          value: _vm.selectedLanguage.customLabel,
                          callback: function($$v) {
                            _vm.$set(_vm.selectedLanguage, "customLabel", $$v)
                          },
                          expression: "selectedLanguage.customLabel"
                        }
                      }),
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "120px" },
                          model: {
                            value: _vm.selectedLanguageCode,
                            callback: function($$v) {
                              _vm.selectedLanguageCode = $$v
                            },
                            expression: "selectedLanguageCode"
                          }
                        },
                        _vm._l(_vm.languageItems, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { label: item.name, value: item.code }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { "margin-top": "-2px" },
                      attrs: { label: " " }
                    },
                    [
                      _c("span", [
                        _c("i", {
                          staticClass: "el-icon-warning",
                          staticStyle: { color: "#e6a23c" }
                        }),
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("SystemMaintenance.AliasOnlyHQ")) +
                            " "
                        )
                      ])
                    ]
                  ),
                  _c("el-form-item", [
                    _c(
                      "span",
                      {
                        staticClass: "title",
                        attrs: { slot: "label" },
                        slot: "label"
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "SystemMaintenance.VisibleToDesignatedPersonnel"
                            )
                          )
                        )
                      ]
                    )
                  ]),
                  _c(
                    "el-form-item",
                    { attrs: { "label-width": "0" } },
                    [
                      _c("cargo-advance-select", {
                        staticStyle: { width: "620px" },
                        attrs: {
                          "select-type": _vm.TYPE_NAMES.basic_data_User,
                          disabled: !_vm.isEdit,
                          "callback-method-type": "value",
                          multiple: "",
                          "default-multiple-value": _vm.toNumArray(
                            _vm.element.multipleRole
                          ),
                          filterable: ""
                        },
                        on: {
                          parentCallBack: function(value) {
                            _vm.multipleRole = _vm.toTxt(value)
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-tab-pane",
            {
              attrs: {
                lazy: true,
                label: _vm.$t("SystemMaintenance.ApplicationSettings"),
                name: "applicationSettings"
              }
            },
            [
              _vm.element.pagePartElement &&
              (_vm.element.pagePartElement.elementName === "unBerthPlanDate" ||
                _vm.element.pagePartElement.elementName ===
                  "estimatedArrivalTime")
                ? [
                    _c(
                      "el-form",
                      {
                        staticStyle: { "margin-top": "20px" },
                        attrs: {
                          "label-width": "120px",
                          "label-position": "left"
                        }
                      },
                      [
                        _c("el-form-item", [
                          _c(
                            "span",
                            {
                              staticClass: "title",
                              attrs: { slot: "label" },
                              slot: "label"
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("SystemMaintenance.DataServiceSetting")
                                )
                              )
                            ]
                          )
                        ]),
                        _c(
                          "el-form-item",
                          { attrs: { "label-width": "0px" } },
                          [
                            _c(
                              "el-checkbox",
                              {
                                staticStyle: { "margin-left": "15px" },
                                model: {
                                  value: _vm.dataServiceNotUpdate,
                                  callback: function($$v) {
                                    _vm.dataServiceNotUpdate = $$v
                                  },
                                  expression: "dataServiceNotUpdate"
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "SystemMaintenance.DataServiceNotUpdateValue"
                                    )
                                  )
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                : _vm._e(),
              _vm.element.pagePartElement &&
              _vm.element.pagePartElement.elementName === "carrierScac"
                ? [
                    _c(
                      "el-form",
                      {
                        staticStyle: { "margin-top": "20px" },
                        attrs: {
                          "label-width": "120px",
                          "label-position": "left"
                        }
                      },
                      [
                        _c("el-form-item", [
                          _c(
                            "span",
                            {
                              staticClass: "title",
                              attrs: { slot: "label" },
                              slot: "label"
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "SystemMaintenance.ReadAndWriteSettings"
                                  )
                                )
                              )
                            ]
                          )
                        ]),
                        _c(
                          "el-form-item",
                          { attrs: { "label-width": "0px" } },
                          [
                            _c(
                              "el-radio-group",
                              {
                                model: {
                                  value: _vm.carrierScacEdit,
                                  callback: function($$v) {
                                    _vm.carrierScacEdit = $$v
                                  },
                                  expression: "carrierScacEdit"
                                }
                              },
                              [
                                _c("el-radio", { attrs: { label: false } }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("CargoMsg.Cargo_ReadOnly"))
                                  )
                                ]),
                                _c("el-radio", { attrs: { label: true } }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("SystemMaintenance.CanEditable")
                                    )
                                  )
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                : _vm._e()
            ],
            2
          )
        ],
        1
      ),
      _c(
        "span",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.okHandler } },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Confirm")))]
          ),
          _c(
            "el-button",
            {
              on: {
                click: function($event) {
                  _vm.innerVisible = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("Message.Cancel")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }